import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector } from '@/hooks';
import { CORRELATION_IDS, selectHttpState } from '@/redux/reducers/http';
import { convertToNumber } from '@/utils';
import { colors, themeParser, useAppTheme } from '@/theme';

const ClientCounter = () => {
  const theme = useAppTheme();
  const clientListResponse = useAppSelector(selectHttpState)[CORRELATION_IDS.GET_CLIENT_LIST];
  const clientListFilterResponse = useAppSelector(selectHttpState)[CORRELATION_IDS.SEND_CLIENT_FILTER];
  const totalItems = convertToNumber(
    clientListFilterResponse?.data ? clientListFilterResponse?.data?.total : clientListResponse?.data?.total,
  );

  return (
    <Box
      sx={{
        padding: '10px 30px',
        fontSize: '12px',
        color: `${themeParser('#000000', colors.primary, theme)} !important`,
      }}
    >
      TOTAL CLIENTS: {totalItems ?? 0}
    </Box>
  );
};

export { ClientCounter };
